import React from 'react';
import { useHistory } from 'react-router-dom';
import PageLayout from '../../Components/pageLayout';
import './index.less';

import qrcode from '../../static/qrcode.jpg';

const Contact: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>联系我们</h1>
                <div className='contact-info'>
                    <h2>联系人信息</h2>
                    <div className='contact-info__list'>
                        <span>联系人：亲亲老师</span>
                        <span>电话：13868063096</span>
                        <span>地址：杭州市杭大路黄龙世纪广场 A座10楼</span>
                        <span>微信小编：yjxygh</span>
                    </div>
                </div>
                <div className='qr-code'>
                    <h2>扫码关注微信公众号</h2>
                    <img src={qrcode} alt="二维码" className='qr-code__image' />
                </div>
            </div>
        } />
    );
};

export default Contact;